module.exports = __webpack_public_path__ + "img/source05_8.9c785b6a.png";